
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/decrease-picture-size",
      function () {
        return require("private-next-pages/decrease-picture-size/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/decrease-picture-size"])
      });
    }
  